module.exports = __webpack_public_path__ + "img/9788954625265.4e73dbda.jpg";